import { Module, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface PsaHubStoreState {
  gradientDetail: {
    showTab: String,
    displayText: String,
    showConfigure: String,
    showManage: String,
    showLaunch: String,
    isOrgEnabled: String,
    isLoading: boolean,
    availableUsers: [],
    assignedUsers: [],
  };
}

export default {
  state: {
    gradientDetail: {
      showTab: '',
      displayText: '',
      showConfigure: '',
      showManage: '',
      showLaunch: '',
      isOrgEnabled: '',
      isLoading: true,
      availableUsers: [],
      assignedUsers: [],
    },
  },
  mutations: {
    setGradientDetail(state, payload) {
      state.gradientDetail = payload;
    },
    setIsLoading(state, payload) {
      state.gradientDetail.isLoading = payload;
    },
  },
  actions: {
    async manageGradient(context: ActionContext<PsaHubStoreState, RootStoreState>, payload: any) {
      context.commit('setIsLoading', true);
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/manage-gradient';
      const res = await ApiServiceWrapper.post(endpoint, payload);
      context.commit('setGradientDetail', res.content);
      context.commit('setIsLoading', false);
      return res;
    },
  },
  getters: {
    getGradientDetails : state => state.gradientDetail,
    isShowTab: state => state.gradientDetail.showTab === 'YES',
    isShowLaunch: state => state.gradientDetail.showLaunch === 'YES',
    isShowManage: state => state.gradientDetail.showManage === 'YES',
    isOrgEnabled: state => state.gradientDetail.isOrgEnabled === 'YES',
    isShowConfigure: state => state.gradientDetail.showConfigure === 'YES',
    getDisplayText: state => state.gradientDetail.displayText,
    getAvailableUsers: state => state.gradientDetail.availableUsers,
    getAssignedUsers: state => state.gradientDetail.assignedUsers,
    isLoading: state => state.gradientDetail.isLoading,
  },
  namespaced: true,
} as Module<PsaHubStoreState, RootStoreState>;
